module.exports = __webpack_public_path__ + "static/media/HTML5.55b4d9a6.png";